<template>
  <div class="coin_wrapper">
    <div class="coin_symbol_wrapper">
      <p v-if="!useIconsByCoinAmount" class="coin_symbol">C</p>
      <img
        v-if="useIconsByCoinAmount"
        class="coin_symbol_img"
        :src="getCoinIconBasedOnCoins(totalAmount)"
      />
    </div>
    <div class="coin_amount_info">
      <div class="coin_campaign" v-if="freeGem > 0 && bonusGem > 0">
        <p class="coin_campaign_label">
          {{
            $t('coinCampaignIncreased', {
              amount: coinFreeAndBonusGem,
            })
          }}
        </p>
      </div>
      <div class="coin_campaign" v-else-if="freeGem > 0">
        <p class="coin_campaign_label">
          {{
            $t('coinCampaignIncreased', {
              amount: coinFreeGem,
            })
          }}
        </p>
      </div>
      <div class="coin_charge_info">
        <span v-if="chargeGem" class="coin_charge_gem">{{
          coinChargeGem
        }}</span>
        <div class="coin_amount_info_media">
          <span v-if="chargeGem" class="right_arrow">→</span>
          <span class="coin_amount">{{ totalCoinAmount }}</span>
          <span v-if="showUnit" class="coin_unit">C</span>
        </div>
      </div>
      <div>
        <p class="coin_info_paid_free">
          <span
            v-if="
              isCampaignProduct && bonusGem > 0 && chargeGem > 0 && freeGem > 0
            "
          >
            {{
              $t('coinSummaryCharge', {
                chargeCoin: this.formatNumber(chargeGem),
              })
            }}
            <br />
            {{
              $t('coinSummaryCampaignFree', {
                freeCoin: this.formatNumber(freeGem),
              })
            }}
          </span>
          <span v-else-if="chargeGem > 0 && freeGem > 0">
            {{
              $t('coinSummaryPaidFree', {
                chargeCoin: this.formatNumber(chargeGem),
                freeCoin: this.formatNumber(freeGem),
              })
            }}
          </span>
          <span v-else-if="chargeGem > 0">
            {{ $t('coinCharge') }}{{ this.formatNumber(chargeGem)
            }}{{ $t('coinName') }}
          </span>
        </p>
      </div>
      <div v-if="bonusGem > 0" class="coin_purchase_bonus_info">
        <p class="coin_purchase_bonus_info_text">
          {{
            $t('coinSummaryMonthlyGradeBonusFree', {
              freeCoin: this.formatNumber(bonusGem),
            })
          }}
        </p>
      </div>
      <div v-if="limitedCount > 0">
        <p class="coin_campaign_info">
          <span v-if="shouldShowTimeLimit"> {{ timeLimitText }}・</span>
          <span>{{
            $tc('coinCampaignLimit', limitedCount, {
              remain: limitedCount,
            })
          }}</span>
        </p>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator'
import Formatter from '@/utils/Formatter'

@Component({})
export default class CoinProduct extends Vue {
  @Prop()
  amount!: number

  @Prop()
  chargeGem!: number

  @Prop()
  freeGem!: number

  @Prop()
  limitedCount!: number

  @Prop({ default: false })
  showUnit!: boolean

  @Prop({ default: false })
  useIconsByCoinAmount!: boolean

  @Prop({ default: false })
  shouldShowTimeLimit!: boolean

  @Prop()
  timeLimitText!: string

  @Prop({ default: false })
  isCampaignProduct!: boolean

  @Prop()
  bonusGem!: number

  get totalAmount() {
    if (this.bonusGem > 0) {
      return this.amount + this.bonusGem
    }
    return this.amount
  }

  get totalCoinAmount() {
    return Formatter.numberWithCommas(this.totalAmount)
  }

  get coinAmount() {
    return Formatter.numberWithCommas(this.amount)
  }

  get coinChargeGem() {
    return Formatter.numberWithCommas(this.chargeGem)
  }

  get coinFreeGem() {
    return Formatter.numberWithCommas(this.freeGem)
  }

  get coinFreeAndBonusGem() {
    return Formatter.numberWithCommas(this.freeGem + this.bonusGem)
  }

  formatNumber(num: number) {
    return Formatter.numberWithCommas(num)
  }

  getCoinIconBasedOnCoins(coins: number): string {
    switch (true) {
      case coins >= 0 && coins <= 499:
        return '../img/coin_icons_v2/coin_01.png'
      case coins >= 500 && coins <= 999:
        return '../img/coin_icons_v2/coin_02.png'
      case coins >= 1000 && coins <= 2999:
        return '../img/coin_icons_v2/coin_03.png'
      case coins >= 3000 && coins <= 4999:
        return '../img/coin_icons_v2/coin_04.png'
      case coins >= 5000 && coins <= 7999:
        return '../img/coin_icons_v2/coin_05.png'
      case coins >= 8000 && coins <= 9999:
        return '../img/coin_icons_v2/coin_06.png'
      case coins >= 10000 && coins <= 24999:
        return '../img/coin_icons_v2/coin_07.png'
      case coins >= 25000 && coins <= 49999:
        return '../img/coin_icons_v2/coin_08.png'
      case coins >= 50000:
        return '../img/coin_icons_v2/coin_09.png'
      default:
        return '../img/coin_icons_v2/coin_01.png'
    }
  }
}
</script>

<style scoped>
.coin_wrapper {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  height: auto;
  line-height: 20px;
}

.coin_symbol_wrapper {
  margin: 0 8px 0 0;

  .coin_symbol {
    width: 20px;
    height: 20px;
    color: #ffffff;
    background-color: #ffb91b;
    border-radius: 50%;
    text-align: center;
    vertical-align: middle;
    font-family: Hiragino Sans;
    font-style: normal;
    font-weight: 700;
    font-size: 10px;
  }

  .coin_symbol_img {
    display: block;
    width: 64px;
    height: 64px;
  }
}

.coin_campaign {
  flex-basis: 100%;
  display: block;
  align-items: center;
  height: 16px;
  line-height: 16px;
  margin: 0px 0px 4px 0px;
}

.coin_campaign_label {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: max-content;
  height: 16px;
  font-size: 12px;
  font-weight: 600;
  list-height: 16px;
  border-radius: 2px;
  margin: 0 16px 0 0;
  padding: 0 4px;
  background-color: #ff003d;
  color: #ffffff;
  border-radius: 4px;
}

.coin_charge_gem {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  text-decoration: line-through;
  font-size: 12px;
  font-weight: 600;
  list-height: 24px;
  height: 24px;
  color: #bababa;
}

.coin_amount_info_media {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.right_arrow {
  padding: 0px 4px 0px 4px;
}

.coin_amount {
  display: inline-flex;
  align-items: center;
  justify-content: center;

  font-size: 16px;
  line-height: 24px;
  height: 24px;
  font-weight: 700;
  color: #262626;
}

.coin_unit {
  font-size: 14px;
  font-weight: 700;
  color: #262626;
  margin-left: 4px;
}

.coin_campaign_info {
  font-size: 12px;
  font-weight: 300;
  color: #808080;
}

.coin_info_paid_free {
  font-size: 10px;
  color: #bababa;
}

.coin_charge_info {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
}

@media (max-width: 345px) {
  .coin_amount_info_media {
    display: block;
  }
}

/** latin alphabet styles */

.-en .coin_campaign,
.-es .coin_campaign,
.-pt-BR .coin_campaign,
.-id .coin_campaign,
.-fr .coin_campaign,
.-ru .coin_campaign,
.-de .coin_campaign,
.-ms .coin_campaign {
  height: 24px;
}

.-en .coin_campaign_label,
.-es .coin_campaign_label,
.-pt-BR .coin_campaign_label,
.-id .coin_campaign_label,
.-fr .coin_campaign_label,
.-ru .coin_campaign_label,
.-de .coin_campaign_label,
.-ms .coin_campaign_label {
  padding: 3px 5px;
}

.-en .coin_campaign_info,
.-es .coin_campaign_info,
.-pt-BR .coin_campaign_info,
.-id .coin_campaign_info,
.-fr .coin_campaign_info,
.-ru .coin_campaign_info,
.-de .coin_campaign_info,
.-ms .coin_campaign_info {
  font-size: 9px;
}

/* russian special case... */

.-ru .coin_campaign {
  display: flex;
  flex-direction: column;
  justify-content: left;
  align-items: flex-start;
  height: 45px;
}

.-ru .coin_campaign_label {
  font-size: 9px;
  padding: 5px 10px;
}

.-ru .coin_campaign_info {
  font-size: 9px;
  padding: 5px 10px;
}

.coin_purchase_bonus_info {
  background-color: #d4eaff;
  border-radius: 4px;
  padding: 0px 4px 0px 4px;

  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.coin_purchase_bonus_info_text {
  font-size: 10px;
  font-weight: 300;
  color: #188dff;
}
</style>
